import { callGetApiToServer } from "../callApi";

export async function getAllAssignedVoucherList(
  authtoken,
  needyFamilyId,
  skipNumber,
  limitNumber
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let endUrl =
      "v1/auth/beneficiary-assigned-voucher-list-admin/" +
      needyFamilyId +
      "/" +
      skipNumber +
      "/" +
      limitNumber;

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
